import React from 'react'
import './AboutDescription.css';
function AboutDescription() {
    return (
        <div className='about-description'>
            <div className='about-description-wrapper'>
                <p>A thriving hub of culture, agriculture, and opportunity located in the Enugu North Senatorial Zone of Enugu State, Nigeria. Established in 1991, following the split of the old Igbo-Eze LGA, Igbo-Eze North is home to the proud people of Enugu Ezike and Ette — two vibrant towns rich in tradition and ambition.</p>
                <p>Our local government is strategically bordered by <strong>Udenu LGA, Kogi State, Benue State</strong>, and <strong>Igbo-Eze South LGA</strong>, making us a vital gateway for commerce and cooperation between Enugu and northern Nigeria.</p>
                <div>
                    <p>With a projected population of over 445,000 residents (2024), Igbo-Eze North boasts:</p>
                    <ul>
                        <li><strong>38 autonomous communities</strong>, each led by traditional rulers or town union executives.</li>
                        <li>A diverse, youthful, and entrepreneurial population predominantly engaged in <strong>agriculture, trade,</strong> and <strong>crafts</strong>.</li>
                        <li>Vast arable land, favorable climate, and a renewed focus on agro-processing and value chain development.</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default AboutDescription